/**
 * Fime – Mega Menu "Our Offering" tabs (single-open per menu).
 * Scoped entirely to .offering-tab / .offering-tab-panel — other
 * mega menus are untouched.
 */

document.querySelectorAll('.offering-tabs').forEach(function (tabsWrapper) {
	const tabs = tabsWrapper.querySelectorAll('.offering-tab');

	tabs.forEach(function (tab) {
		tab.addEventListener('mouseenter', function () {
			const targetId = tab.dataset.offeringTab;
			const panelWrapper = tabsWrapper.closest('.offering-tabs-wrapper');

			tabs.forEach(function (t) {
				t.classList.remove('is-active');
				t.setAttribute('aria-selected', 'false');
			});
			tab.classList.add('is-active');
			tab.setAttribute('aria-selected', 'true');

			panelWrapper.querySelectorAll('.offering-tab-panel').forEach(function (panel) {
				panel.classList.toggle('hidden', panel.id !== targetId);
			});
		});
	});
});
